// Cycle-day helpers shared by the cycle-mode (period_based) menu screens.
// getCycleDayForDate mirrors the backend's dateToCycleDay — the double-mod
// keeps dates before startDate mapping to a valid 1..lengthDays value.
// getCurrentCycleDay resolves "today" to its cycle day so screens can open on it.

export const getCycleDayForDate = (dateStr, startDateStr, lengthDays) => {
    if (!dateStr || !startDateStr || !lengthDays) return null;
    const date = new Date(dateStr);
    const start = new Date(startDateStr);
    const daysSinceStart = Math.round((date - start) / (1000 * 60 * 60 * 24));
    return (((daysSinceStart % lengthDays) + lengthDays) % lengthDays) + 1;
};

export const getCurrentCycleDay = (cycleConfig) => {
    if (!cycleConfig?.startDate || !cycleConfig?.lengthDays) return null;
    const today = new Date().toISOString().split("T")[0];
    return getCycleDayForDate(today, cycleConfig.startDate, cycleConfig.lengthDays);
};
